import {ValidationType} from './ValidationType'

export const CertificatesValidation = {
  ID: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  ContactID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  PropertyID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  IssuerID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  CertificateTypeID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  UserID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  AddedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  UpdatedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  Reference: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 30,
    maxValue: 0
  },
  StartDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  EndDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  Status: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  EERCurrent: {
    validationType: ValidationType.NumericNeg,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  EERPotential: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  EIRCurrent: {
    validationType: ValidationType.NumericNeg,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  EIRPotential: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  EERCurrentMin: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  EERPotentialMin: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  EIRCurrentMin: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  EIRPotentialMin: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 29,
    maxValue: 79228162514264337593543950335
  },
  UploadPDF: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  InActive: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  }
};
